import React, { useEffect, useState } from "react";
import ProductCard from "../components/ProductCard";
import { getProducts } from "../lib/api";
import Seo from "../components/Seo";

const Ofertas = () => {
  const [productos, setProductos] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let isMounted = true;
    setLoading(true);
    getProducts({ limit: 200 })
      .then((data) => {
        if (isMounted) {
          setProductos(data.filter((producto) => producto.sale_price));
        }
      })
      .catch(() => {
        if (isMounted) setProductos([]);
      })
      .finally(() => {
        if (isMounted) setLoading(false);
      });
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Seo
        title="Ofertas de tenis"
        description="Aprovecha ofertas en tenis y zapatillas seleccionadas. Descuentos y envios rapidos en Eclipse Tenis."
      />
      <div className="bg-gradient-to-r from-red-600 to-pink-600 text-white py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Ofertas Especiales</h1>
          <p className="text-xl">Aprovecha nuestros descuentos en zapatillas seleccionadas</p>
        </div>
      </div>

      <div className="container mx-auto px-4 py-16">
        {loading && <p className="text-sm text-gray-500">Cargando ofertas...</p>}
        {!loading && productos.length > 0 ? (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {productos.map((producto) => (
              <ProductCard key={producto.id} producto={producto} />
            ))}
          </div>
        ) : null}
        {!loading && productos.length === 0 ? (
          <div className="text-center py-16">
            <p className="text-gray-500 text-lg">No hay ofertas disponibles en este momento</p>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default Ofertas;
